/* THIS IS A GENERATED FILE, DO NOT EDIT */
export const JsqOperationNames = {
  Query: {
    GetAsyncJob: 'GetAsyncJob',
    GetAsyncJobProgress: 'GetAsyncJobProgress',
    GetTransactionTypes: 'GetTransactionTypes',
    GetCurrentUser: 'GetCurrentUser',
    GetESignatureCCLogDump: 'GetESignatureCCLogDump',
    GetInvestorDiligenceCCLog: 'GetInvestorDiligenceCCLog',
    GetProspect: 'GetProspect',
    BulkPositionCreationArenas: 'BulkPositionCreationArenas',
    BulkPositionCreationEntities: 'BulkPositionCreationEntities',
    GetArenaTransactionExportJobs: 'GetArenaTransactionExportJobs',
    GetContactsViewedDocument: 'GetContactsViewedDocument',
    GetInvestmentEntitiesByArenaLegacy: 'GetInvestmentEntitiesByArenaLegacy',
    GetArenaTransactionTypes: 'GetArenaTransactionTypes',
    GetTransactionAllocationTypes: 'GetTransactionAllocationTypes',
    GetTransactionsDeletionUrl: 'GetTransactionsDeletionUrl',
    GetTransactionDescriptions: 'GetTransactionDescriptions',
    FeatureFlagAuditQuery: 'FeatureFlagAuditQuery',
    DevFeatureFlags: 'DevFeatureFlags',
    getEmailDistributionListsForEditArena: 'getEmailDistributionListsForEditArena',
    getDocumentCategoriesForEditArena: 'getDocumentCategoriesForEditArena',
    GetArenaDetails: 'GetArenaDetails',
    GetArenasWithPagination: 'GetArenasWithPagination',
    GetEditionFeatureFlags: 'GetEditionFeatureFlags',
    getUnifiedPortalFeatureFlag: 'getUnifiedPortalFeatureFlag',
    GetEditArenaDevFeatureFlags: 'GetEditArenaDevFeatureFlags',
    GetArenasSortedByName: 'GetArenasSortedByName',
    GetSessionLogs: 'GetSessionLogs',
    GetArenaInfoById: 'GetArenaInfoById',
    GetRecoveryCodesForUser: 'GetRecoveryCodesForUser',
    GetUsers: 'GetUsers',
    GetArenaName: 'GetArenaName',
    GetRoles: 'GetRoles',
    GetGroupsLegacy: 'GetGroupsLegacy',
    CurrentUserQuery: 'CurrentUserQuery',
    GetNestedOwnershipFeatureFlag: 'GetNestedOwnershipFeatureFlag',
    GetClientNameById: 'GetClientNameById',
    GetArenasWithSearch: 'GetArenasWithSearch',
    GetEntitiesWithSearch: 'GetEntitiesWithSearch',
    GetAllCurrencies: 'GetAllCurrencies',
    GetArena: 'GetArena',
    GetArenas: 'GetArenas',
    GetEntities: 'GetEntities',
    BackgroundTask: 'BackgroundTask',
    GetEntityWithTransactionCounts: 'GetEntityWithTransactionCounts',
    GetEntityDeltas: 'GetEntityDeltas',
    GetEntityTransferSettings: 'GetEntityTransferSettings',
    GetEntityMixFundStatus: 'GetEntityMixFundStatus',
    GetSsoStatusForAdmin: 'GetSsoStatusForAdmin',
    GetFundAdminServices: 'GetFundAdminServices',
    GetGroups: 'GetGroups',
    CanopyGroupUsers: 'CanopyGroupUsers',
    GetCcToolsUser: 'GetCcToolsUser',
    GetCCToolsUsers: 'GetCCToolsUsers',
    GetWorkspaces: 'GetWorkspaces'
  },
  Mutation: {
    EditArena: 'EditArena',
    DeactivateArena: 'DeactivateArena',
    ReactivateArena: 'ReactivateArena',
    CreateUserLegacy: 'CreateUserLegacy',
    EditUserLegacy: 'EditUserLegacy',
    GenerateTotp: 'GenerateTotp',
    DownloadTwrData: 'DownloadTwrData',
    DowngradeStaffOrHybridUserToEmail2FA: 'DowngradeStaffOrHybridUserToEmail2FA',
    generatePresignedUrls: 'generatePresignedUrls',
    ArenaTransactionsExport: 'ArenaTransactionsExport',
    mergeDocumentCategories: 'mergeDocumentCategories',
    TransactionDeletionFields: 'TransactionDeletionFields',
    UpdateDevFeatureFlags: 'UpdateDevFeatureFlags',
    CreateWorkbook: 'CreateWorkbook',
    UserLogin: 'UserLogin',
    uploadFundDocs: 'uploadFundDocs',
    EditUser: 'EditUser',
    CreateUser: 'CreateUser'
  },
  Fragment: {
    ArenaFields: 'ArenaFields',
    EditArenaFields: 'EditArenaFields',
    AsyncJobFields: 'AsyncJobFields',
    SubscriptionCCLogDumpFields: 'SubscriptionCCLogDumpFields',
    TransactionDescriptionFields: 'TransactionDescriptionFields',
    UserFields: 'UserFields',
    RoleFields: 'RoleFields',
    GroupFields: 'GroupFields',
    UserAccessFields: 'UserAccessFields',
    EntityFields: 'EntityFields'
  }
}